import { useState, useEffect } from "react";
import { useAuth } from "@/hooks/useAuth";
import { supabase } from "@/integrations/supabase/client";

export type AppRole = "admin" | "user" | "staff";

export const useUserRole = () => {
  const { user } = useAuth();
  const [roles, setRoles] = useState<AppRole[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRoles = async () => {
      if (!user) {
        setRoles([]);
        setLoading(false);
        return;
      }

      try {
        const { data, error } = await supabase
          .from("user_roles")
          .select("role")
          .eq("user_id", user.id);

        if (error) {
          console.error("Error fetching user roles:", error);
          setRoles(["user"]);
        } else {
          const list = (data || []).map((r: any) => r.role as AppRole);
          setRoles(list.length > 0 ? list : ["user"]);
        }
      } catch (error) {
        console.error("Error fetching user roles:", error);
        setRoles(["user"]);
      } finally {
        setLoading(false);
      }
    };

    fetchRoles();
  }, [user]);

  const isAdmin = roles.includes("admin");
  const isStaff = roles.includes("staff");
  const role: AppRole = isAdmin ? "admin" : isStaff ? "staff" : "user";

  return { role, roles, isAdmin, isStaff, loading };
};
